import {
  faCheck,
  faExclamation,
  faEye,
  faInfo,
  faTimes
} from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import clsx from 'clsx'
import { type PropsWithChildren, useState } from 'react'
import {
  alertBase,
  alertClose,
  alertCloseVariations,
  alertIcon,
  alertIconVariations,
  alertMain,
  alertVariations
} from '~/components/Global/Interactions/Alert/Alert.css'
import { AlertVariation } from '~/components/Global/Interactions/Alert/AlertVariation'

const Icon = ({ variation }: { variation: AlertVariation }) => {
  if (
    variation === AlertVariation.Primary ||
    variation === AlertVariation.Secondary
  ) {
    return <FontAwesomeIcon icon={faEye} />
  }
  if (variation === AlertVariation.Info) {
    return <FontAwesomeIcon icon={faInfo} />
  }
  if (variation === AlertVariation.Success) {
    return <FontAwesomeIcon icon={faCheck} />
  }
  if (
    variation === AlertVariation.Danger ||
    variation === AlertVariation.Warning
  ) {
    return <FontAwesomeIcon icon={faExclamation} />
  }
}

export const Alert = ({
  message,
  variation = AlertVariation.Primary,
  onDismiss,
  children
}: PropsWithChildren<{
  message: string
  variation: AlertVariation
  onDismiss?: () => void
}>) => {
  const [isClosed, setIsClosed] = useState(false)

  if (isClosed) {
    return <></>
  }

  return (
    <div className={clsx(alertBase, alertVariations[variation])}>
      <div className={clsx(alertIcon, alertIconVariations[variation])}>
        <Icon variation={variation} />
      </div>
      <div className={alertMain}>
        {message && <div>{message}</div>}
        <div>{children}</div>
      </div>
      <button
        type="button"
        onClick={() => {
          setIsClosed(true)
          onDismiss?.()
        }}
        className={clsx(alertClose, alertCloseVariations[variation])}
      >
        <FontAwesomeIcon icon={faTimes} />
      </button>
    </div>
  )
}
